import { render, staticRenderFns } from "./getUnidades.vue?vue&type=template&id=087bf60e&"
import script from "./getUnidades.vue?vue&type=script&lang=js&"
export * from "./getUnidades.vue?vue&type=script&lang=js&"
import style0 from "./getUnidades.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports